import { createStyles } from "@mui/styles";

export const useStyles = (theme) =>
  createStyles({
    button: {
      padding: theme.spacing(2, 3),
      [theme.breakpoints.down("sm")]: {
        position: "none",
        padding: theme.spacing(1, 3) + "!important",
      },
      [theme.breakpoints.up("sm")]: {},
      [theme.breakpoints.up("md")]: {},
      "&:disabled": {},
    },
    buttonText: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        padding: theme.spacing(0.5, 0),
      },
      [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(0.5, 0),
      },
      [theme.breakpoints.up("md")]: {
        padding: theme.spacing(0.5, 0),
      },
    },
    mainCta: {
      width: "100%",
      whiteSpace: "nowrap",
      padding: theme.spacing(0, 3),
    },
  });
